import React, { memo, useEffect } from 'react';

import { Route, Switch } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';

import { ThemeProvider } from '@material-ui/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import { ErrorPage } from '@episource/analyst-ui-components';

import { ConnectedRouter } from 'connected-react-router';

import Home from './containers/Home';
import Help from './components/Help';
import PrivacyCheck from './containers/PrivacyCheck';
import { theme } from './theme';
import Administration from './containers/Administration';
// eslint-disable-next-line import/no-named-as-default
import Profile from './containers/UserProfile';

import auth0Client from './utils/auth0Client';
import { LoadTknInfo } from './actions/auth';
import { clearLoadingClient } from './actions/clients';
import { AuthenticationErrorPage } from './containers/AuthenticationErrorPage';
import { SuccessRedirect } from './containers/SuccessRedirect';

const detectErrorMessage = () => {
  const { hash } = window.location;
  return hash && hash.includes('error')
    ? hash
        .replace('#', '')
        .split('&')
        .reduce((errors, error) => {
          const [name, message] = error.split('=');
          return {
            ...errors,
            [name]: message,
          };
        }, {})
    : null;
};

const pollingInterval = process.env.REACT_APP_POLLING_INTERVAL || 900000;

function App(props) {
  // eslint-disable-next-line react/prop-types
  const { history, onChangeTkn, onClearLoadingClient } = props;

  useEffect(() => {
    async function checkValidSession() {
      const validSession = await auth0Client.validateSession();
      if (!validSession) {
        auth0Client.signIn();
      }
    }
    setInterval(() => {
      checkValidSession();
    }, pollingInterval);
  }, []);

  async function CheckAuth() {
    if (auth0Client.checkAuthentication()) {
      return true;
    }
    if (!auth0Client.loadTknManually(window.location.href)) {
      auth0Client.signIn();
      return false;
    }
    onClearLoadingClient();
    auth0Client.getDataUserInfo();
    onChangeTkn(auth0Client.getIdToken(), auth0Client.getAccessToken(), auth0Client.getProfile());
    return true;
  }

  const ReRouteAuth = (pass, fail) => {
    const authError = detectErrorMessage();
    if (authError)
      return (
        <AuthenticationErrorPage message={authError.error_description} state={authError.state} />
      );
    return CheckAuth() ? pass : fail;
  };

  return (
    <>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <ConnectedRouter history={history}>
          <Switch>
            <Route exact path="/success-redirect" component={SuccessRedirect} />
            <Route exact path="/" render={() => ReRouteAuth(<Home />, <></>)} />
            <Route
              path="/administration"
              render={() => ReRouteAuth(<Administration history={history} />, <></>)}
            />
            <Route exact path="/settings" render={() => ReRouteAuth(<Home />, <></>)} />
            <Route exact path="/profile" render={() => ReRouteAuth(<Profile />, <></>)} />
            <Route path="/help/:appName/:lob?" component={Help} />
            <Route path="/help" component={Help} />
            <Route exact path="/privacyCheck" render={() => <PrivacyCheck />} />
            <Route component={ErrorPage} />
          </Switch>
        </ConnectedRouter>
      </ThemeProvider>
    </>
  );
}

App.propTypes = {
  onChangeTkn: PropTypes.func.isRequired,
  onClearLoadingClient: PropTypes.func.isRequired,
};

const mapStateToProps = createStructuredSelector({});

export function mapDispatchToProps(dispatch) {
  return {
    onChangeTkn: (idToken, accessToken, profile) =>
      dispatch(LoadTknInfo(idToken, accessToken, profile)),
    onClearLoadingClient: () => dispatch(clearLoadingClient()),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, memo)(App);
